import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const image = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name'),

    fileName: z.string().nullable().optional().hidden().describe('File Name'),

    mimeType: z.string().nullable().optional().hidden().describe('Mime Type'),

    size: z.number().nullable().optional().hidden().describe('Size'),

    base64Content: z
      .string()
      .nullable()
      .optional()
      .hidden()
      .describe('Base64 Content'),

    fixedPosition: z.boolean().nullable().optional().describe('Fixed Position'),

    sequence: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Sequence - Display order'),

    positionX: z.number().nullable().optional().hidden().describe('Position X'),

    positionY: z.number().nullable().optional().hidden().describe('Position Y'),

    isBackground: z.boolean().nullable().optional().describe('Is Background'),

    locked: z.boolean().nullable().optional().hidden().describe('locked'),

    resourceId: z.number().hidden().describe('Foreign key to Resource'),

    resource: belongsTo('Resource'),
  })
  .describe('A positioned image within a resource.')
  .as('Image');

export { image as imageSchema };
